import React from 'react';

export default function NavItem({ icon: Icon, label, active, collapsed, onClick }) {
  return (
    <button
      onClick={onClick}
      title={collapsed ? label : undefined}
      aria-current={active ? 'page' : undefined}
      className={[
        'group flex items-center gap-3 w-full rounded-xl text-sm font-medium',
        'transition-colors duration-150 ease-snap',
        collapsed ? 'justify-center px-2.5 py-2.5' : 'px-3 py-2.5',
        active
          ? 'bg-brand-600 text-white shadow-sm'
          : 'text-ink-muted hover:text-ink hover:bg-surface-subtle',
      ].join(' ')}
    >
      <Icon
        size={18}
        className={active ? 'text-white' : 'text-ink-subtle group-hover:text-ink'}
        strokeWidth={2}
      />
      {!collapsed && <span className="truncate">{label}</span>}
    </button>
  );
}
